import React, { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import apiClient from "../../apiClient";
import { HeadBackIcon, SideArrow } from "../../Assets/Icons";
import { GET_CATEGORY_CHILD_LIST } from "../../apiClient/apiEndPoints";
import { debounce, getWindowDimensions } from "../../utils/common";
import { removeUserData } from "../../store/slice/userSlice";

const Sidebar = ({
  setMobileShowSideBar,
  mobileShowSideBar,
  parentCategory,
  setParentCategory,
  handleDebounceBackClick,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const params = useParams();
  const { id } = params;
  const [categoryList, setCategoryList] = useState({});
  const [platform, setPlatform] = useState("universal");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [screenMobile, setScreenMobile] = useState(true);

  const getAllCategory = async () => {
    try {
      setLoading(true);
      let findCategoryChild = categoryList[id]?.children;

      if (findCategoryChild) {
        findCategoryChild.length > 0 && setList(findCategoryChild);
        setParentCategory(categoryList[id].parent);
      }

      let data = await apiClient.get(`${configData.config.UNO_URL}${GET_CATEGORY_CHILD_LIST}/${platform}/${id}`);
      let child = data.children.map((item) => ({
        id: item.id,
        name: item.name,
        haveChildren: item.children.length > 0 ? true : false,
      }));

      if (child.length > 0) {
        setList(child);
      }

      let parentData = {
        id: configData.config["3dAssetsId"],
        name: "All Category",
      };

      if (child.length > 0) {
        parentData.name = id == configData.config["3dAssetsId"] ? "All Category" : data.name;
        parentData.id = id == configData.config["3dAssetsId"] ? configData.config["3dAssetsId"] : data.parent.id;
      } else {
        parentData.name =
          id == configData.config["3dAssetsId"] || configData.config["3dAssetsId"] == data.parent.id
            ? "All Category"
            : data.parent.name;
        parentData.id =
          id == configData.config["3dAssetsId"] ||
          configData.config["3dAssetsId"] == data.parent.id ||
          child.length === 0
            ? configData.config["3dAssetsId"]
            : data.parent.id;
      }

      setParentCategory(parentData);

      setParentCategory(parentData);

      setCategoryList((pre) => ({
        ...pre,
        [id]: {
          children: child,
          parent: parentData,
          categoryName: data.name,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, [id]);

  const handleClickCategory = (id) => {
    handleHideMobileSideBar();
    navigate(`/category/${id}`);
  };

  const handleResize = () => {
    const { mode } = getWindowDimensions();
    setScreenMobile(mode === "Landscape" ? false : true);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleHideMobileSideBar = () => {
    document.body.classList.remove("active-sidebar");
    setMobileShowSideBar(false);
  };

  const handleUserLogOut = async () => {
    try {
      await axios.post(
        `${configData?.config.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(removeUserData());
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = `${configData.config.redirectUri}`;
    }
  };

  const placeholderUserName = userData?.user?.name
    ?.split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

  return (
    <>
      {screenMobile && mobileShowSideBar && (
        <span className="bg-forside" onClick={handleHideMobileSideBar}>
          {""}
        </span>
      )}
      <div className={screenMobile ? `sidebar mobile ${mobileShowSideBar ? "active" : ""}` : "sidebar"}>
        {screenMobile ? (
          <div className="head">
            <div class="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              {userData?.user?.avatar ? (
                <img src={userData?.user?.avatar} referrerPolicy={"no-referrer"} />
              ) : (
                <span className="placeholder-"> {placeholderUserName} </span>
              )}
              <span class="name-email">
                <h6>{userData?.user?.name}</h6>
                <p>{userData?.user?.designation}</p>
              </span>
            </div>
          </div>
        ) : (
          <div className="head">
            {/* {id != configData.config["3dAssetsId"] && <span onClick={handleDebounceBackClick}> <HeadBackIcon /> </span>}
            {(id == configData.config["3dAssetsId"] || parentCategory.id == configData.config["3dAssetsId"] ) ? "All Category" : categoryList[id]?.categoryName} */}
            {(id != configData.config["3dAssetsId"] || id != parentCategory.id) && (
              <span onClick={handleDebounceBackClick}>
                {" "}
                <HeadBackIcon />{" "}
              </span>
            )}
            {parentCategory?.name || "All Category"}
          </div>
        )}

        <div className="list-parent">
          <>
            <div className="cate-list">
              {loading ? (
                <>
                  {screenMobile && (
                    <div className="cate-item head">
                      <Skeleton width="90%" height="100%" />
                    </div>
                  )}
                  <div className="cate-item">
                    <Skeleton width="90%" height="100%" />
                  </div>
                  <div className="cate-item">
                    <Skeleton width="90%" height="100%" />
                  </div>
                  <div className="cate-item">
                    <Skeleton width="90%" height="100%" />
                  </div>
                  <div className="cate-item">
                    <Skeleton width="90%" height="100%" />
                  </div>
                </>
              ) : (
                <>
                  {screenMobile && (
                    <div className="cate-item head">
                      {/* {id != configData.config["3dAssetsId"] && <span onClick={handleBackButton}> <HeadBackIcon /> </span>}
                    {id == configData.config["3dAssetsId"] ? "All Category" : categoryList[id]?.categoryName} */}
                      {(id != configData.config["3dAssetsId"] || id != parentCategory.id) && (
                        <span onClick={handleDebounceBackClick}>
                          {" "}
                          <HeadBackIcon />{" "}
                        </span>
                      )}
                      {parentCategory?.name || "All Category"}
                    </div>
                  )}

                  {list &&
                    list.map((item) => {
                      return (
                        <>
                          <div
                            key={item.id}
                            className={`cate-item ${id == item.id ? "active" : ""}`}
                            onClick={() => handleClickCategory(item.id)}
                            navigate
                          >
                            {item.name}
                            {item.haveChildren && <SideArrow />}
                          </div>
                          {/* <div className="select-tags">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={true}
                              />
                            }
                            label={item.name}
                          />
                        </div> */}
                        </>
                      );
                    })}
                </>
              )}
            </div>
          </>
        </div>

        {screenMobile && (
          <div className="lognSim">
            <span className="log-out-mob" onClick={handleUserLogOut}>
              {" "}
              Sign Out{" "}
            </span>
            <span className="powerd">
              {" "}
              Powered by <strong> Simulanis </strong>{" "}
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
